import { createFileRoute } from "@tanstack/react-router"
import { CompanyIntegrations } from "modules/settings/components/integrations/CompanyIntegrations"

export const Route = createFileRoute("/_base/_auth/settings/integrations/")({
  component: CompanyIntegrations,
})
